<!-- /src/components/common/List/ListStyle.vue -->
<template>
  <div class="list-item">
    <router-link
      :to="{ name: routeToName, params: { sessionType: postType, slug } }"
      class="list-item__content"
    >
      <div class="list-item__content__container"
        :class="{
          'list-item__content__container__has-MVP': isMVP,
          'list-item__content__container__has-ICON': showIcon,
        }"
      >
        <i v-if="showIcon" class="list-item_type icon fas" :class="sessionTypeIcon"></i>
        <div class="list-item__title__container">
          <div class="list-item__title">
            <h3 v-html="post.post_title"></h3>
          </div>
          <div v-if="authorFeaturing" class="list-item__author">
            {{ authorFeaturing }} 
          </div>
        </div>
        <div v-if="isMVP"
          class="list-item__mvp-banner"
        >
          MVP
        </div>
      </div>
    </router-link>
    <footer v-if="showBookmarkButton || showProgressStatus" class="list-item__footer">
      <div class="list-item__actions">
        <button
          v-if="showBookmarkButton"
          class="list-item__actions__item button button--sm button--shadow"
          :class="bookmarkClasses"
          @click.stop.prevent="addBookmark"
        >
          <span class="button__icon">
            <i v-if="bookmarkLoading" class="icon fas fa-spinner fa-pulse"></i>
            <i v-else-if="bookmarked" class="icon fas fa-bookmark"></i>
            <i v-else class="icon far fa-bookmark"></i></span>
        </button>
        <router-link
          v-if="showProgressStatus"
          :to="{ name: routeToName, params: { sessionType: postType, slug } }"
          class="list-item__actions__item button button--sm list-item__actions__item--progress"
          :class="progressClasses"
        >
          <span class="button__icon">
            <i class="icon" :class="progressIcons"></i>
          </span>
        </router-link>
      </div>
    </footer>
  </div>
</template>

<script>
// import AuthorChip from '@/components/Bio/AuthorChip'
import secondConversions from '@/components/common/utils/filters/secondConversions'
import postMixin from '@/mixins/postMixin'

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    removeElements: {
      type: [Array, Object],
      required: false,
    },
  },

  computed: {
    showIcon() {
      const { removeElements } = this
      console.log(removeElements)
      if (typeof removeElements != 'undefined' && removeElements.length > 0) {
        return !(removeElements.includes('icon'))
      }
      return true
    },
    showBookmarkButton() {
      const { removeElements } = this
      if (typeof removeElements != 'undefined' && removeElements.length > 0) {
        return !(removeElements.includes('bookmarks'))
      }
      return true
    },
    showProgressStatus() {
      const { removeElements } = this
      if (typeof removeElements != 'undefined' && removeElements.length > 0) {
        return !(removeElements.includes('progressStatus'))
      }
      return true
    },
    
  },

  mixins: [postMixin],

  // components: {
  //   AuthorChip,
  // },

  filters: {
    ...secondConversions,
  },
}
</script>

<style scoped>
.list-item {
  /* background-color: white; */
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  width: 100%;
  box-shadow: 0 0 1rem rgba(154, 162, 178, 0);
  transition: box-shadow 0.5s ease, transform 0.5s ease;
  /* overflow: hidden; */
  will-change: box-shadow, transform;
  height: 100%;

  &:hover {
    box-shadow: 0 0.5rem 1rem rgba(154, 162, 178, 0.5);
    transform: translateY(-5px);

    .list-item__bottom {
      background-color: var(--brandAccent);
    }
  }

  @media (--tablet) {
    margin-bottom: 0;
  }

  &__text {
    margin-left: 0.5rem;
    line-height: 1;
  }

  &__content {
    cursor: pointer;

    &__container {
      padding: 1rem 1rem 0.75rem 1rem;
      height: 100%;

      &__has-ICON {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        grid-gap: .5rem;
      }

      &__has-MVP {
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        grid-gap: .5rem;
      }
    }
  }

  &__mvp-banner {
    background-color: var(--brandAccent);
    border-radius: 4px 4px 0 4px;
    transform: translateX(1.5rem);
    padding: .2rem 1.75rem .2rem .5rem;
    color: white;
    font-size: .8rem;
    font-weight: 800;

    &::after {
      content: "";
      background-color: #ac5412;
      width: .5rem;
      height: .5rem;
      bottom: -.5rem;
      right: 0;
      z-index: 5;
      position: absolute;
      clip-path: polygon(0% 0%, 100% 0%, 0% 100%)
    }

  }

  &__footer {
    display: grid;
    transition: 0.5s background-color;
    background-color: var(--mediumGray);
    height: 100%;
    align-content: center;
  }

  &_type {
    &.icon {
      color: white;
      text-align: center;
      background-color: var(--brandAccent);
      border-radius: 50%;
      padding: 0.5em;
      width: 2em;
      height: 2em;
      position: relative;

      &:before {
        position: absolute;
        left: 50%;
        top: 50%;

        transform: translate(-50%, -50%);
      }

      &.fa-play {
        &:before {
          left: 55%;
        }
      }
    }

    /* &__container {
      display: grid;
      justify-content: start;
    } */
  }

  &__title {
    color: var(--brandPrimary);
    line-height: 1.1;
    font-size: 0.9rem;
    letter-spacing: -0.05em;
    font-weight: 500;

    h3 {
      font-weight: var(--fontWeightBold);
      margin: 0;
      /* max-width: 100%; */

      @media (--desktop-large) {
        /* font-size: 1.4rem; */
      }
    }
  }

  &__date,
  &__duration {
    font-size: 0.7rem;
    vertical-align: middle;
  }

  &__author {
    margin: 0.25rem 0 0 0;
    color: var(--brandAccent);
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.75em;
    line-height: 1.1;
  }

  &__tags {
    font-size: 0.6rem;
    display: inline-flex;
    flex-wrap: wrap;
    margin-bottom: 0;

    &__tag {
      display: inline;
      margin-right: 0.45em;
      font-weight: 500;

      &:after {
        content: ',';
      }

      &:last-child {
        margin-right: 0;

        &:after {
          content: '';
        }
      }
    }
  }

  &__actions {
    padding: 0.75rem 1rem;
    font-size: 0.5rem;
    font-weight: var(--fontWeightSemibold);
    text-align: center;
    /* grid-template-columns: repeat(auto-fit, auto); */
    /* grid-gap: .5rem; */
    height: 100%;
    /* align-items: center; */

    &__item {
      display: inline-block;
      /* width: 100%; */
      font-size: 1.2em;
      margin-right: 0.5em;
      min-width: 40px;

      &:last-child {
        margin-right: 0;
      }

      &--progress {
        color: var(--lightGray);
        text-transform: uppercase;
        font-weight: var(--fontWeightBold);
        letter-spacing: -0.03em;
      }
    }
  }
}
</style>
